import * as hotTableActions from '../actions/hotTableActions';
import * as legacyHotTableActions from '../legacy/actions/hotTableActions';
import { TableDataVersion } from '../../../../common/table/TableTypes';
import { useLegacyActiveTableDataVersion } from '../store/legacyHotTableStoreHooks';

export const useTableActionsSwitch = () => {
    const tableDataVersion = useLegacyActiveTableDataVersion();

    return tableDataVersion === TableDataVersion.V2 ? hotTableActions : legacyHotTableActions;
};
